import { Injectable } from '@angular/core';
import { addIcons } from 'ionicons';
import { 
    homeOutline, storefrontOutline, imageOutline, imagesOutline, constructOutline, barChartOutline, briefcaseOutline, pieChartOutline, exitOutline,
    menuOutline, arrowBackOutline, closeOutline, chevronBackOutline, chevronForwardOutline, alertCircleOutline, checkmarkCircleOutline,
    warningOutline, closeCircleOutline, mailOutline, keyOutline, eyeOutline, eyeOffOutline, syncOutline, searchOutline, refreshOutline,
    businessOutline, cartOutline, mapOutline, trailSignOutline, checkmarkOutline, locationOutline, addOutline, mailUnreadOutline, 
    calendarOutline, timeOutline, hourglassOutline, thumbsDownOutline, thumbsUpOutline, caretUpOutline, caretDownOutline, peopleOutline,
    personOutline, star, informationCircleOutline, cashOutline, documentOutline, micOutline, micOffOutline, openOutline, bookmarksOutline,
    downloadOutline, pencilOutline, documentTextOutline, arrowRedoOutline, swapHorizontalOutline, arrowDownOutline, arrowForwardOutline,
    rocketOutline, callOutline, duplicateOutline, mailOpenOutline, newspaperOutline, trashOutline, moon, moonOutline, carOutline,
    podiumOutline, listOutline, helpCircleOutline, bookOutline, chevronDownOutline, chevronUpOutline, checkboxOutline, squareOutline,
    settings, albumsOutline
} from 'ionicons/icons';

@Injectable({
    providedIn: 'root'
})
export class IconsService {

    constructor() { }
    
    init(){
        addIcons({
            homeOutline, 
            storefrontOutline, 
            imageOutline, 
            imagesOutline,
            constructOutline, 
            barChartOutline, 
            briefcaseOutline, 
            pieChartOutline, 
            exitOutline,
            menuOutline,
            arrowBackOutline,
            closeOutline,
            chevronBackOutline,
            chevronForwardOutline,
            alertCircleOutline,
            checkmarkCircleOutline,
            warningOutline,
            closeCircleOutline,
            mailOutline,
            keyOutline,
            eyeOutline,
            eyeOffOutline,
            syncOutline,
            searchOutline,
            refreshOutline,
            businessOutline,
            cartOutline,
            mapOutline,
            trailSignOutline,
            checkmarkOutline,
            locationOutline,
            addOutline,
            mailUnreadOutline,
            calendarOutline,
            timeOutline,
            hourglassOutline,
            thumbsDownOutline, 
            thumbsUpOutline,
            caretUpOutline, 
            caretDownOutline,
            peopleOutline,
            personOutline,
            star,
            informationCircleOutline,
            cashOutline,
            documentOutline,
            micOutline,
            micOffOutline,
            openOutline,
            bookmarksOutline,
            downloadOutline,
            pencilOutline,
            documentTextOutline,
            arrowRedoOutline,
            swapHorizontalOutline,
            arrowDownOutline,
            arrowForwardOutline,
            rocketOutline,
            callOutline,
            duplicateOutline,
            mailOpenOutline,
            newspaperOutline,
            trashOutline, 
            moon, 
            moonOutline,
            carOutline,
            podiumOutline,
            listOutline,
            helpCircleOutline,
            bookOutline, 
            chevronDownOutline, 
            chevronUpOutline, 
            checkboxOutline, 
            squareOutline,
            settings,
            albumsOutline
        });
    }
    
}

